<script setup>
import { useAnchorTitle } from '~/composables/useAnchorTitle'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    default: '',
  },
  items: {
    type: Object,
    required: true,
  },
})

const anchorTitle = computed(() => useAnchorTitle(props.title))
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-12 col-800-10 col-1200-8 matrix">
      <div class="spacer-60-50">
        <h2
          v-if="title"
          :id="anchorTitle"
          class="scale-3 scale-3--bold-uppercase"
          :class="{ 'spacer-25-20': text }"
        >
          {{ title }}
        </h2>
        <p
          class="equal-base"
          v-html="text"
        />
      </div>
      <div
        v-if="items.length === 1"
        class="matrix__highlight"
      >
        <SlideStory :slide="items[0]" />
      </div>
      <div
        v-if="items.length === 2"
        class="d-none d-800-flex matrix__grid"
      >
        <SlideStory :slide="items[0]" />
        <SlideStory :slide="items[1]" />
      </div>
      <div
        v-if="items.length === 3"
        class="matrix__grid--small"
      >
        <Slider
          :show-pagination="true"
          :wrap-around="true"
          :slides="items"
          align="center"
          class="slider--overflow slider--fade-out"
        >
          <template #default="slide">
            <SlideStory :slide="slide" />
          </template>
        </Slider>
      </div>
      <div
        v-if="items.length >= 4"
        class="matrix__grid--large"
      >
        <Slider
          :show-pagination="true"
          :wrap-around="true"
          :slides="items"
          align="center"
          class="slider--overflow slider--fade-out"
        >
          <template #default="slide">
            <SlideStory :slide="slide" />
          </template>
        </Slider>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/node_modules/bootstrap/scss/mixins';

.matrix {
  p {
    margin: 0;
  }

  &__highlight {
    height: 60vh;
    max-height: clamp(425px, 17.71vw + 368.33px, 680px);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: clamp(25px, 2.43vw + 17.22px, 60px);

    @include media-breakpoint-down(800) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  .matrix__grid--small {
    :deep(.embla__slide) {
      flex: 0 0 83.333%; /* Default slide covers 100% of the viewport */
    }
    @media (min-width: 800px) {
      :deep(.embla__slide) {
        flex: 0 0 50%; /* Breakpoint SM slide covers 50% of the viewport */
      }
    }
    @media (min-width: 1200px) {
      :deep(.embla__slide) {
        flex: 0 0 40%; /* Breakpoint SM slide covers 50% of the viewport */
      }
    }
  }
  .matrix__grid--large {
    :deep(.embla__slide) {
      flex: 0 0 83.333%; /* Default slide covers 100% of the viewport */
    }
    @media (min-width: 800px) {
      :deep(.embla__slide) {
        flex: 0 0 50%; /* Breakpoint SM slide covers 50% of the viewport */
      }
    }
    @media (min-width: 1200px) {
      :deep(.embla__slide) {
        flex: 0 0 28.571%; /* Breakpoint SM slide covers 50% of the viewport */
      }
    }
  }
}
</style>
